import { throttle } from 'lodash';

const state = {
  visualViewport: {
    enabled: true,
    width: window.innerWidth,
    height: window.innerHeight,
    styleTag: null,
    updaterFunction: null,
    scrollCount: 0,
  },
};

const getters = {
  getVisualViewportHeight: (state) => state.visualViewport.height,
  getVisualViewportWidth: (state) => state.visualViewport.width,
  getVisualViewportScroll: (state) => state.visualViewport.scrollCount,
};

const actions = {
  updateVisualViewport({ state, commit }) {
    if (state.visualViewport.enabled) {
      commit('updateVisualViewport');
      commit('updateVisualViewportStyleTag');
      state.visualViewport.scrollCount++;
    }
  },
  initializeVisualViewport({ state, dispatch }) {
    if (state.visualViewport.styleTag) {
      return;
    }

    state.visualViewport.styleTag = document.createElement('style');
    document.head.append(state.visualViewport.styleTag);

    dispatch('updateVisualViewport');

    state.visualViewport.updaterFunction = throttle(() => {
      dispatch('updateVisualViewport');
    }, 16);

    window.visualViewport.addEventListener('resize', state.visualViewport.updaterFunction);
    window.addEventListener('scroll', state.visualViewport.updaterFunction);
  },
  destroyVisualViewportListener({ state }) {
    window.visualViewport.removeEventListener('resize', state.visualViewport.updaterFunction);
    window.removeEventListener('scroll', state.visualViewport.updaterFunction);
  },
};

const mutations = {
  updateVisualViewport(state) {
    if (!window.visualViewport) {
      state.visualViewport.enabled = false;
      return;
    }
    state.visualViewport.height = window.visualViewport.height;
    state.visualViewport.width = window.visualViewport.width;
  },
  updateVisualViewportStyleTag(state) {
    state.visualViewport.styleTag.innerHTML = `
      :root {
        --100vvh: ${window.visualViewport.height}px;
        --verticalOffset: ${window.innerHeight - window.visualViewport.height}px;
      }
    `;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
